// ─────────────────────────────────────────────────────────────────────
// DeviceId del navegador para el sistema de monitorización.
//
// **NO inventamos UUIDs**: usamos el `SessionIdentifier` que ya genera
// el sistema en `setSession` (slice authJwt) y se persiste en
// `localStorage["sessionIdentifier"]`. Ese mismo identificador:
//   - Se manda como header `SessionIdentifier` en CADA petición axios.
//   - Se persiste en la tabla `Devices.UserSessionIdentifier` del backend.
//   - Es el ID con el que el restaurante ve sus dispositivos en
//     Ajustes → Sesiones (con su `Name` legible: "TPV cocina", etc.).
//
// Usando el mismo ID, el panel de monitorización puede hacer JOIN con
// `Devices` y mostrar el nombre real del dispositivo en lugar de un
// UUID feo o ambiguo.
//
// Fallback: si el usuario no está logueado todavía (login screen, etc.)
// caemos a `"anonymous-{tab-uuid}"` — datos sin contexto pero no rompen.
// ─────────────────────────────────────────────────────────────────────

import { readStoredSessionIdentifier } from "./deviceSessionCore";

const ANON_KEY = "tmo-anon-device-id";

function getOrCreateAnonId() {
  try {
    let id = localStorage.getItem(ANON_KEY);
    if (!id) {
      id = `anon-${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 8)}`;
      localStorage.setItem(ANON_KEY, id);
    }
    return id;
  } catch {
    return "anonymous-device";
  }
}

export function getDeviceId() {
  // "" / "null" (restos de un login sin identificador) no son un dispositivo.
  const sid = readStoredSessionIdentifier();
  if (sid) return sid;
  return getOrCreateAnonId();
}

export default getDeviceId;
